export default "__VITE_ASSET__CaZrL8f4__"